module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_dicot_root_2-03b561e46e325564376ca1a28fa10308.jpg";